export const ApplicationLabel = () => (
    <span className='display-flex column-gap-5 white-space-nowrap'>
        <span>UIKIT</span>
    </span>
);
